import Request from '@/plugins/request';

export function getTempRebates(params) {
  return Request.get('temp-rebates', { params })
}

export function createTempRebates() {
  return Request.get(`temp-rebates/create`)
}

export function storeTempRebates(data) {
  return Request.post('temp-rebates', data)
}

export function updateTempRebates(id, data) {
  return Request.put(`temp-rebates/${id}`, data)
}

export function editTempRebates(id) {
  return Request.get(`temp-rebates/${id}/edit`)
}

export function destroyTempRebates(id) {
  return Request.delete(`temp-rebates/${id}`)
}


export function deductBonusManage(id, data) {
  return Request.post(`temp-rebates/deductBonus/${id}`, data)
}

export function tempRebateLogsList(params) {
  return Request.post(`temp-rebate-logs/list`, params)
}
